import { render, staticRenderFns } from "./ServiceCompleteTemplate.vue?vue&type=template&id=be5a8902"
import script from "./ServiceCompleteTemplate.vue?vue&type=script&lang=js"
export * from "./ServiceCompleteTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports